// constants.ts
export const StatusOptionsConstant = [
    { label: 'Status.Active', value: 1, status: 1 },
    { label: 'Status.Inactive', value: 2, status: 1 },
    // { label: 'status.pending', value: 3 , status: 0}
];

export const IsLockOptionsConstant = [
    { label: 'Status.Lock', value: true },
    { label: 'Status.Unlock', value: false }
];

export const YesNoOptionsConstant = [
    { label: 'Status.Yes', value: true },
    { label: 'Status.No', value: false }
];

export const TriggerOptionsConstant = [
    { label: 'TriggerType.Auto', value: 'Auto' },
    { label: 'TriggerType.Click', value: 'Click' }
]

export const UploadThemeCssConstant: Record<string, { container: string; controller: string; action: string }> = {
    Admin: {
        container: "content",
        controller: "ContentAdminSetting",
        action: "UploadContentAdminSettingFile",
    },
    Merchant: {
        container: "content",
        controller: "ContentMerchantSetting",
        action: "UploadContentMerchantSettingFile",
    },
    MemberUnlimited: {
        container: "content",
        controller: "ContentUnMemberSetting",
        action: "UploadContentUnMemberSettingFile",
    },
};


export const UploadImageConstant: Record<string, { container: string; controller: string; action: string }> = {
    SystemCountry: {
        container: "system",
        controller: "SystemSettingCountry",
        action: "UploadSystemSettingCountryImage",
    },
    SystemCurrency: {
        container: "system",
        controller: "SystemSettingCurrency",
        action: "UploadSystemSettingCurrencyImage",
    },
    ContentAdmin: {
        container: "content",
        controller: "ContentAdminSetting",
        action: "UploadContentAdminSettingImage",
    },
    ContentMerchant: {
        container: "content",
        controller: "ContentMerchantSetting",
        action: "UploadContentMerchantSettingImage",
    },
    ContentMerchantAnnouncement: {
        container: "content",
        controller: "ContentMerchantAnnouncement",
        action: "UploadContentMerchantAnnouncementImage",
    },
    ContentUnMember: {
        container: "content",
        controller: "ContentUnMemberSetting",
        action: "UploadContentUnMemberSettingImage",
    },
    ContentUnMemberAvatar: {
        container: "content",
        controller: "ContentUnmemberAvatar",
        action: "UploadContentUnMemberAvatarImage",
    },
    ContentUnMemberBanner: {
        container: "content",
        controller: "ContentUnMemberBanner",
        action: "UploadContentUnMemberBannerImage",
    },
    ContentUnMemberTutorial: {
        container: "content",
        controller: "ContentUnMemberTutorial",
        action: "UploadContentUnMemberTutorialImage",
    },
    SystemMessage: {
        container: "system",
        controller: "SystemSettingMessage",
        action: "UploadSystemSettingMessageImage",
    },
    ContentUnMemberMessageOtp: {
        container: "content",
        controller: "ContentUnMemberMessageOtp",
        action: "UploadContentUnMemberMessageOtpImage",
    },
    SystemGame: {
        container: "system",
        controller: "SystemSettingGame",
        action: "UploadSystemSettingGameImage",
    },
    ContentUnMemberGame: {
        container: "content",
        controller: "ContentUnMemberGame",
        action: "UploadContentUnMemberGameImage",
    },
    ContentUnAgentAnnouncementSingle: {
        container: "content",
        controller: "ContentUnAgentAnnouncementSingle",
        action: "UploadContentUnAgentAnnouncementSingleImage",
    },
    ContentUnAgentAnnouncementMultiple: {
        container: "content",
        controller: "ContentUnAgentAnnouncementMultiple",
        action: "UploadContentUnAgentAnnouncementMultipleImage",
    },
    ContentUnMemberAnnouncementSingle: {
        container: "content",
        controller: "ContentUnMemberAnnouncementSingle",
        action: "UploadContentUnMemberAnnouncementSingleImage",
    },
    ContentUnMemberAnnouncementMultiple: {
        container: "content",
        controller: "ContentUnMemberAnnouncementMultiple",
        action: "UploadContentUnMemberAnnouncementMultipleImage",
    },
};

export const WebTypeConstant = {
    ADMIN: "Admin",
    ADMINSTAFF: "AdminStaff",
    MERCHANT: "Merchant",
    MERCHANTSTAFF: "MerchantStaff",
    AGENTUNLIMITED: "AgentUnlimited",
    AGENTSTAFFUNLIMITED: "AgentStaffUnlimited",
    MEMBERUNLIMITED: "MemberUnlimited"
} as const;
export type WebTypeConstant = (typeof WebTypeConstant)[keyof typeof WebTypeConstant];

export const SupportedLanguageConstant: { code: string; index: number; displayName: string; icon: string; required: boolean; }[] = [
  { code: 'en-US', index: 0, displayName: 'English', icon: '/assets/images/lang/en-us.png', required: true},
  { code: 'zh-CN', index: 1, displayName: '简体中文', icon: '/assets/images/lang/zh-cn.png', required: false},
  { code: 'zh-TW', index: 2, displayName: '繁體中文', icon: '/assets/images/lang/zh-tw.png', required: false},
  { code: 'ms-MY', index: 3, displayName: 'Bahasa Melayu', icon: '/assets/images/lang/ms-my.png', required: false},
  { code: 'id-ID', index: 4, displayName: 'Bahasa Indonesia', icon: '/assets/images/lang/id-id.png', required: false},
  { code: 'th-TH', index: 5, displayName: 'ภาษาไทย', icon: '/assets/images/lang/th-th.png', required: false},
  { code: 'vi-VN', index: 6, displayName: 'Tiếng Việt', icon: '/assets/images/lang/vi-vn.png', required: false }
];
